import React, { useEffect, useState } from "react";
import {
  LicenseTypes,
  Operation,
  PageFor,
} from "../../../../../../utils/Enum.types";
import Navbar from "../../../../../common/layout/Navbar";
import ItemSelect from "../../../../../../customComponents/ItemSelect";
import { Keys } from "../../../../../../utils/Enum.keys";
import {
  handleMUISelectEvent,
  reOrderProcess,
} from "../../../../../../utils/UtilFunctions";
import Input from "../../../../../../stories/Input/Input";
import { Title } from "../../../../../../stories/Title/Title";
import useLabels from "../../../../../../customHooks/useLabels";
import { Label } from "../../../../../../stories/Label/Label";
import { Button } from "../../../../../../stories/Button/Button";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  AddItemErrorMsg,
  DeleteItemErrorMsg,
  ReOrdertemErrorMsgs,
  UpdateItemErrorMsg,
} from "./queries/mutations";
import {
  AddItemErrorMsgResult,
  AddItemErrorMsgVar,
  AtsStckItemErrors,
  DeleteItemErrorMsgResult,
  DeleteItemErrorMsgvar,
  GetItemErrorMsgsResult,
  GetItemErrorMsgsvar,
  ReOrdertemErrorMsgsResult,
  ReOrdertemErrorMsgsVar,
  UpdateItemErrorMsgResult,
  UpdateItemErrorMsgVar,
} from "./queries/types";
import { emptyMessage } from "../../../../../../utils/constants";

import useUrlParams from "../../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import { GetItemErrorMsgs } from "./queries/queries";
import MessageModal from "../../../../../../customComponents/MessageModal";
import LoadingModal from "../../../../../pages/LoadingModal";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { TableHeaderProps } from "../../../../../../utils/types";
import {
  HEADER_TEXT_ALIGN,
  SLNO_TEXT_ALIGN,
} from "../../../../../../styles/Variables";
import Edit from "../../../../../../images/EditProfile.svg";
import DeleteImg from "../../../../../../images/Delete.svg";
import {
  DragDropContext,
  Draggable,
  DraggableProvided,
  DraggableStateSnapshot,
  Droppable,
  DroppableProvided,
  DropResult,
} from "react-beautiful-dnd";
import InputHoc from "../../../../../common/Input/Index";
import DeleteModal from "../../../../../../customComponents/DeleteModal";
import Reorder from "../../../../../../images/ReOrder.svg";
interface Props {
  pageType: PageFor;
}

const dynamicHeaders: TableHeaderProps[] = [
  {
    headerName: "Sl",
    field: "id",
    headerAlign: HEADER_TEXT_ALIGN,
    align: SLNO_TEXT_ALIGN,
  },
  {
    headerName: `Error Message`,
    field: "errMsg",
    headerAlign: HEADER_TEXT_ALIGN,
    align: SLNO_TEXT_ALIGN,
    flex: 1,
  },
  {
    headerName: `Actions`,
    field: "Actions",
    headerAlign: HEADER_TEXT_ALIGN,
    align: SLNO_TEXT_ALIGN,
    flex: 1,
  },
];

const ItemErrorMessage = ({ pageType }: Props) => {
  const { itemLabel } = useLabels();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    itemId: 0,
    itemLabel: "",
    errMsg: "",
    errMsgID: 0,
  });
  const [message, setMessage] = useState(emptyMessage);
 
  const { customer_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();
  const [reOrder, setReOrder] = useState(false);
  const [localItems, setLocalItems] = useState<AtsStckItemErrors[]>([]);
  const [operation, setOperation] = useState(Operation.CREATE);
  const [deleteModal, setDeleteModal] = useState(false);

  const [addItemErrorMsg, { loading: addLoading }] = useMutation<
    AddItemErrorMsgResult,
    AddItemErrorMsgVar
  >(AddItemErrorMsg, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [getItemErrorMsgs, { data, loading }] = useLazyQuery<
    GetItemErrorMsgsResult,
    GetItemErrorMsgsvar
  >(GetItemErrorMsgs);

  const [updateItemErrorMsg, { data: UpdateData, loading: UpdateLoading }] =
    useMutation<UpdateItemErrorMsgResult, UpdateItemErrorMsgVar>(
      UpdateItemErrorMsg,
      {
        onError: (e) => {
          setMessage({
            flag: true,
            message: e.message,
            operation: Operation.NONE,
          });
        },
      }
    );

  const [deleteItemErrorMsg, { data: deleteData, loading: deleteLoading }] =
    useMutation<DeleteItemErrorMsgResult, DeleteItemErrorMsgvar>(
      DeleteItemErrorMsg,
      {
        onError: (e) => {
          setMessage({
            flag: true,
            message: e.message,
            operation: Operation.NONE,
          });
        },
      }
    );

  const [
    reOrdertemErrorMsgs,
    { data: ReOrdertemErrorMsgsData, loading: reorderLoading },
  ] = useMutation<ReOrdertemErrorMsgsResult, ReOrdertemErrorMsgsVar>(
    ReOrdertemErrorMsgs,
    {
      onError: (e) => {
        setMessage({
          flag: true,
          message: e.message,
          operation: Operation.NONE,
        });
      },
    }
  );

  const handleSubmit = async () => {
    try {
   
      if (customer_id && formData.itemId) {
        if (operation === Operation.CREATE) {
          addItemErrorMsg({
            variables: {
          
              customerID: customer_id,
              user_details,
              itemID: formData.itemId,
              input: [
                {
                  errMsg: formData.errMsg,
                  idx: 0,
                },
              ],
            },
            refetchQueries: [
              {
                query: GetItemErrorMsgs,
                variables: {
              
                  customerID: customer_id,
                  itemID: formData.itemId,
                },
              },
            ],
          }).then(({ data }) => {
            if (data && data.AddItemErrorMsg) {
              setMessage({
                flag: true,
                message: `Added successfully`,
                operation: Operation.CREATE,
              });
            }
          });
        } else {
          updateItemErrorMsg({
            variables: {
          
              customerID: customer_id,
              user_details,
              errMsgID: formData.errMsgID,
              errMsg: formData.errMsg,
            },
            refetchQueries: [
              {
                query: GetItemErrorMsgs,
                variables: {
              
                  customerID: customer_id,
                  itemID: formData.itemId,
                },
              },
            ],
          }).then(({ data }) => {
            if (data && data.UpdateItemErrorMsg) {
              setMessage({
                flag: true,
                message: `Updated successfully`,
                operation: Operation.UPDATE,
              });
            }
          });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSaveOrder = async () => {
    try {
     
      if (customer_id) {
        reOrdertemErrorMsgs({
          variables: {
            customerID: customer_id,
        
            user_details,
            input: localItems?.map((res, index) => ({
              errMsgID: res.id,
              idx: index + 1,
            })),
          },
          refetchQueries: [
            {
              query: GetItemErrorMsgs,
              variables: {
            
                customerID: customer_id,
                itemID: formData.itemId,
              },
            },
          ],
        }).then(({ data }) => {
          if (data && data.ReOrdertemErrorMsgs) {
            setMessage({
              flag: true,
              message: `Re-Order Successful`,
              operation: Operation.UPDATE,
            });
            setReOrder(!reOrder);
          }
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const HandleDelete = async () => {
    try {
     
      if (customer_id) {
        setDeleteModal(false);

        deleteItemErrorMsg({
          variables: {
        
            user_details,
            customerID: customer_id,
            errMsgIds: [formData.errMsgID],
          },
          refetchQueries: [
            {
              query: GetItemErrorMsgs,
              variables: {
            
                customerID: customer_id,
                itemID: formData.itemId,
              },
            },
          ],
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const fetchItemsErrMsgs = async () => {
      try {
       
        if (customer_id && formData.itemId) {
          getItemErrorMsgs({
            variables: {
          
              customerID: customer_id,
              itemID: formData.itemId,
              itemDetailsID: 0,
            },
          });
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchItemsErrMsgs();
  }, [customer_id, formData.itemId]);

  useEffect(() => {
    if (data && data.GetItemErrorMsgs) {
      setLocalItems(
        data.GetItemErrorMsgs?.filter((itemResponse) => itemResponse !== null)
      );
    }
  }, [data, loading]);

  const handleDragEnd = (result: DropResult) => {
    if (!result.destination) {
      return;
    }
    if (result.destination.index === result.source.index) {
      return;
    }

    setLocalItems((prev) => {
      const temp = [...prev];

      reOrderProcess(result, temp);
      return temp;
    });
  };

  const handleClear = () => {
    setMessage({
      flag: false,
      message: "",
      operation: Operation.CREATE,
    });
  };

  const handleClose = () => {
    handleClear();
    setOperation(Operation.CREATE);
    setFormData({
      ...formData,
      errMsgID: 0,
      errMsg: "",
    });
  };

  return (
    <>
      {pageType === PageFor.GENERAL && (
        <Navbar NavType={LicenseTypes.CUSTOMER_USERS} />
      )}
      <Title>Stock {itemLabel} Error Message</Title>

      <Formik
        initialValues={formData}
        // validationSchema={itemErrorValidation}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnChange
      >
        {(meta) => {
          return (
            <Form className="items-err-msg">
              <div className="items-err-msg__datablock row g-0">
                <div className="items-err-msg__datablock--left col">
                  <div className="items-err-msg__add">
                    <Title variant="subtitle1">
                      {operation === Operation.UPDATE ? "Update " : "Add "}
                      {itemLabel}
                    </Title>
                    <div className="items-err-msg__add--form">
                      <div
                        className={
                          operation === Operation.UPDATE ? " " : "label-grid"
                        }
                      >
                        {operation === Operation.UPDATE ? null : (
                          <Label>{itemLabel}</Label>
                        )}

                        {operation === Operation.UPDATE ? (
                          <>
                            <InputHoc
                              values={formData.itemLabel}
                              name="Asset"
                              disabled
                              LabelName={itemLabel}
                            />
                          </>
                        ) : (
                          <>
                            <ItemSelect
                              onChange={(newValue) => {
                                if (newValue) {
                                  setFormData({
                                    ...formData,
                                    itemId: newValue.value,
                                    itemLabel: newValue.label,
                                  });
                                } else {
                                  setFormData({
                                    ...formData,
                                    itemId: 0,
                                    itemLabel: "",
                                  });
                                  setLocalItems([]);
                                }
                              }}
                              onKeyDown={(e) => {
                                if (e.key === Keys.ENTER) {
                                  e.preventDefault();
                                  handleMUISelectEvent(e);
                                }
                              }}
                              value={formData.itemId}
                              placeholder=""
                            />
                          </>
                        )}
                      </div>
                      <div className="label-grid">
                        <Label>Error message</Label>
                        <Input
                          value={formData.errMsg}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              errMsg: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="items-err-msg__datablock--right col">
                  <Title variant="subtitle1">
                    List of {itemLabel} Error Message
                  </Title>
                  <div className="items-err-msg__datablock--tableblock">
                    <TableContainer className="items-err-msg__datablock--table">
                      <Table stickyHeader>
                        <TableHead>
                          <TableRow>
                            {reOrder ? <TableCell></TableCell> : null}

                            {dynamicHeaders
                              .filter(
                                ({ field }: TableHeaderProps) =>
                                  !(field === "Actions" && reOrder)
                              )
                              .map((th: TableHeaderProps, index: React.Key) => {
                                return (
                                  <React.Fragment key={index}>
                                    <TableCell>{th.headerName}</TableCell>
                                  </React.Fragment>
                                );
                              })}
                          </TableRow>
                        </TableHead>

                        <DragDropContext onDragEnd={handleDragEnd}>
                          <Droppable
                            droppableId="droppable"
                            direction="vertical"
                          >
                            {(droppableProvided: DroppableProvided) => (
                              <TableBody
                                ref={droppableProvided.innerRef}
                                {...droppableProvided.droppableProps}
                              >
                                {localItems?.map((response, index: number) => (
                                  <Draggable
                                    key={index}
                                    draggableId={index.toString()}
                                    index={index}
                                    isDragDisabled={!reOrder}
                                  >
                                    {(
                                      draggableProvided: DraggableProvided,
                                      snapshot: DraggableStateSnapshot
                                    ) => {
                                      return (
                                        <React.Fragment key={index}>
                                          <TableRow
                                            key={index}
                                            ref={draggableProvided.innerRef}
                                            {...draggableProvided.draggableProps}
                                          >
                                            {reOrder ? (
                                              <TableCell
                                                {...draggableProvided.dragHandleProps}
                                                id="td-center"
                                                className="institution__table--slno"
                                              >
                                                =
                                              </TableCell>
                                            ) : null}
                                            <TableCell
                                              id="td-center"
                                              {...draggableProvided.dragHandleProps}
                                              className="institution__table--slno"
                                            >
                                              {index + 1}
                                            </TableCell>

                                            <TableCell
                                              {...draggableProvided.dragHandleProps}
                                            >
                                              {response.errMsg}
                                            </TableCell>

                                            {reOrder === false ? (
                                              <TableCell
                                                id="td-center"
                                                {...draggableProvided.dragHandleProps}
                                                className="institution__table--action"
                                              >
                                                <>
                                                  <img
                                                    src={Edit}
                                                    alt="/"
                                                    onClick={() => {
                                                      setFormData({
                                                        ...formData,
                                                        errMsgID: response.id,
                                                        errMsg: response.errMsg,
                                                      });

                                                      setOperation(
                                                        Operation.UPDATE
                                                      );
                                                    }}
                                                  />
                                                  <img
                                                    src={DeleteImg}
                                                    alt="/"
                                                    onClick={() => {
                                                      setFormData({
                                                        ...formData,
                                                        errMsgID: response.id,
                                                        errMsg: "",
                                                      });
                                                      setDeleteModal(
                                                        !deleteModal
                                                      );
                                                    }}
                                                  />
                                                </>
                                              </TableCell>
                                            ) : null}
                                          </TableRow>
                                        </React.Fragment>
                                      );
                                    }}
                                  </Draggable>
                                ))}
                                {droppableProvided.placeholder}
                              </TableBody>
                            )}
                          </Droppable>
                        </DragDropContext>
                      </Table>
                    </TableContainer>
                  </div>
                  {localItems?.length > 1 ? (
                    reOrder ? (
                      <>
                        <Button
                          type="button"
                          onClick={handleSaveOrder}
                          mode="save"
                        >
                          -order
                        </Button>
                        <Button
                          mode="clear"
                          type="button"
                          onClick={() => {
                            setReOrder(!reOrder);
                            setLocalItems(
                              data?.GetItemErrorMsgs?.filter(
                                (classResponse) => classResponse !== null
                              )!
                            );
                          }}
                        />
                      </>
                    ) : (
                      <Button
                        type="button"
                        onClick={() => setReOrder(!reOrder)}
                      >
                        <img src={Reorder} alt="" /> Reorder
                      </Button>
                    )
                  ) : null}
                </div>
              </div>
              <Button mode="save" type="submit" />

              <Button mode="back" type="button" onClick={() => navigate(-1)} />
            </Form>
          );
        }}
      </Formik>

      <DeleteModal
        id={formData.errMsgID}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={HandleDelete}
      />

      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal
        flag={
          loading ||
          addLoading ||
          UpdateLoading ||
          reorderLoading ||
          deleteLoading
        }
      />
    </>
  );
};

export default ItemErrorMessage;
